import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { UploadingFile } from '@/types';

const state = () => ({
  uploadingFiles: [] as UploadingFile[],
});

export default {
  state,
  getters,
  actions,
  mutations,
};
